<script>
import { fetchDetailByServiceId } from '@/services/api'
export default {
  name: "service",
  props: {
    serviceId: {
      type: String,
      default: undefined
    },
  },
  data() {
    return {
      serviceInfo: {}
    }
  },
  watch: {
    serviceId: {
      immediate: true,
      handler() {
        this.reload();
      }
    },
  },
  methods: {
    reload() {
      if(this.serviceId == undefined) {
        console.error('请提供service-id')
      }
      this.loadServiceInfo();
    },
    loadServiceInfo() {
      fetchDetailByServiceId({
        serviceId: this.serviceId
      }).then(res => {
        this.serviceInfo = res.data.serviceInfo
      })
    },
    buy() {
      this.$emit('jump',{
        messageType: 'FYTL:Service',
        content: {
          serviceId: this.serviceId
        }
      })
    },

    sendService() {
      this.$emit('send-service', {
        serviceId: this.serviceInfo.serviceId,
        servicePic: this.serviceInfo.serviceImage,
        serviceName: this.serviceInfo.serviceName,
        price: this.serviceInfo.servicePrice,
      })
    }
  }
}
</script>

<template>
  <div class="service">
    <img :src="serviceInfo.serviceImage">
    <span class="text">{{ serviceInfo.serviceName }}</span>
    <span class="price">{{ serviceInfo.servicePrice }}</span>
    <button class="buy" @click="buy">去购买</button>
    <button class="send" @click="sendService">发送服务</button>
  </div>
</template>

<style lang="less" scoped>
.service {
  position: relative;
  &:hover {
    background: #F8F8F8;
  }
  background: #ffffff;
  height: 150px;
  border-bottom: 1px solid #E4E9F2;

  img {
    width: 80px;
    height: 80px;
    border-radius: 12px;
    margin: 20px 10px;
  }
  .text {
    position: absolute;
    left: 100px;
    top: 25px;
    width: calc(100% - 110px);
    height: 40px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .price {
    position: absolute;
    left: 100px;
    top: 80px;
    width: calc(~'100% - 110px');
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 19px;
    color: #FF1010;
    &:before {
      content: '￥';
    }
  }
  button {
    position: absolute;
    bottom: 10px;
  }
  .buy {
    left: 108px;
  }
  .send {
    right: 20px;
  }
}
button {
   width: 86px;
   height: 30px;
   background-color: #ffffff;
   border: 1px solid #78849E;
   border-radius: 15px;
   margin-right: 10px;
   font-size: 12px;
   font-family: Microsoft YaHei;
   font-weight: 400;
   line-height: 16px;
   color: #78849E;
   transition: all .15s;

   &:hover {
     background: #EEF3FA;
   }

   &:active {
     background: #D7F2F9;
   }
 }
</style>